import { useEffect, useState, useRef } from "react";
import { apiRequest } from "../config/api";

// Fallback product data for when API fails
const fallbackYarnProducts = [
  {
    id: "fallback-1",
    name: "Krafty Baby Milk Cotton",
    brand: "Krafty",
    price: 115,
    originalPrice: 125,
    rating: 4.5,
    reviews: 28,
    image: "/companies/krafty.jpg",
    badge: "TOP SELLING",
    slug: "krafty-baby-milk-cotton",
    variants: [
      {
        id: "fallback-variant-1",
        sku: "KBMC-001",
        price_regular: 115,
        price_sale: 115,
        stock: 50,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/krafty.jpg",
            alt_text: "Krafty Baby Milk Cotton",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "cotton", name: "Cotton", slug: "cotton" } },
    ],
    tags: [{ tag: { id: "soft", name: "Soft", slug: "soft", color: "blue" } }],
    images: [
      {
        url: "/companies/krafty.jpg",
        alt_text: "Krafty Baby Milk Cotton",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.5 }],
  },
  {
    id: "fallback-2",
    name: "Cicibebe Batik",
    brand: "Cicibebe",
    price: 250,
    originalPrice: 275,
    rating: 4.7,
    reviews: 15,
    image: "/companies/cicibebe.jpg",
    badge: "NEW",
    slug: "cicibebe-batik",
    variants: [
      {
        id: "fallback-variant-2",
        sku: "CB-001",
        price_regular: 250,
        price_sale: 250,
        stock: 30,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/cicibebe.jpg",
            alt_text: "Cicibebe Batik",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "acrylic", name: "Acrylic", slug: "acrylic" } },
    ],
    tags: [
      {
        tag: {
          id: "colorful",
          name: "Colorful",
          slug: "colorful",
          color: "purple",
        },
      },
    ],
    images: [
      {
        url: "/companies/cicibebe.jpg",
        alt_text: "Cicibebe Batik",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.7 }],
  },
  {
    id: "fallback-3",
    name: "Krafty Baby Chenille",
    brand: "Krafty",
    price: 280,
    originalPrice: 325,
    rating: 4.8,
    reviews: 42,
    image: "/companies/krafty.jpg",
    badge: "PREMIUM",
    slug: "krafty-baby-chenille",
    variants: [
      {
        id: "fallback-variant-3",
        sku: "KBC-001",
        price_regular: 280,
        price_sale: 280,
        stock: 25,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/krafty.jpg",
            alt_text: "Krafty Baby Chenille",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "chenille", name: "Chenille", slug: "chenille" } },
    ],
    tags: [
      {
        tag: { id: "premium", name: "Premium", slug: "premium", color: "gold" },
      },
    ],
    images: [
      {
        url: "/companies/krafty.jpg",
        alt_text: "Krafty Baby Chenille",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.8 }],
  },
  {
    id: "fallback-4",
    name: "Krafty Baby Chenille Fine",
    brand: "Krafty",
    price: 189,
    originalPrice: 250,
    rating: 4.6,
    reviews: 35,
    image: "/companies/krafty.jpg",
    badge: "BEST SELLER",
    slug: "krafty-baby-chenille-fine",
    variants: [
      {
        id: "fallback-variant-4",
        sku: "KBCF-001",
        price_regular: 189,
        price_sale: 189,
        stock: 40,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/krafty.jpg",
            alt_text: "Krafty Baby Chenille Fine",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "chenille", name: "Chenille", slug: "chenille" } },
    ],
    tags: [
      {
        tag: {
          id: "bestseller",
          name: "Best Seller",
          slug: "bestseller",
          color: "green",
        },
      },
    ],
    images: [
      {
        url: "/companies/krafty.jpg",
        alt_text: "Krafty Baby Chenille Fine",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.6 }],
  },
];

const fallbackAccessoryProducts = [
  {
    id: "fallback-acc-1",
    name: "Pony Crochet Hook Set",
    brand: "Pony",
    price: 485,
    originalPrice: 0,
    rating: 4.7,
    reviews: 156,
    image: "/needles.webp",
    badge: "PREMIUM QUALITY",
    slug: "pony-crochet-hook-set",
    variants: [
      {
        id: "fallback-acc-variant-1",
        sku: "PCH-001",
        price_regular: 485,
        price_sale: 485,
        stock: 20,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/needles.webp",
            alt_text: "Pony Crochet Hook Set",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      {
        category: {
          id: "accessories",
          name: "Accessories",
          slug: "accessories",
        },
      },
    ],
    tags: [
      {
        tag: { id: "premium", name: "Premium", slug: "premium", color: "gold" },
      },
    ],
    images: [
      {
        url: "/needles.webp",
        alt_text: "Pony Crochet Hook Set",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.7 }],
  },
  {
    id: "fallback-acc-2",
    name: "3D Punch Needle Set",
    brand: "CraftMaster",
    price: 399,
    originalPrice: 0,
    rating: 4.5,
    reviews: 89,
    image: "/needles_with_cloth.webp",
    badge: "CREATIVE TOOL",
    slug: "3d-punch-needle-set",
    variants: [
      {
        id: "fallback-acc-variant-2",
        sku: "3DPN-001",
        price_regular: 399,
        price_sale: 399,
        stock: 15,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/needles_with_cloth.webp",
            alt_text: "3D Punch Needle Set",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      {
        category: {
          id: "accessories",
          name: "Accessories",
          slug: "accessories",
        },
      },
    ],
    tags: [
      {
        tag: {
          id: "creative",
          name: "Creative",
          slug: "creative",
          color: "purple",
        },
      },
    ],
    images: [
      {
        url: "/needles_with_cloth.webp",
        alt_text: "3D Punch Needle Set",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.5 }],
  },
  {
    id: "fallback-acc-3",
    name: "Bag Buckles",
    brand: "CraftMaster",
    price: 50,
    originalPrice: 0,
    rating: 4.3,
    reviews: 67,
    image: "/pattern.png",
    badge: "ESSENTIAL",
    slug: "bag-buckles",
    variants: [
      {
        id: "fallback-acc-variant-3",
        sku: "BB-001",
        price_regular: 50,
        price_sale: 50,
        stock: 100,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/pattern.png",
            alt_text: "Bag Buckles",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      {
        category: {
          id: "accessories",
          name: "Accessories",
          slug: "accessories",
        },
      },
    ],
    tags: [
      {
        tag: {
          id: "essential",
          name: "Essential",
          slug: "essential",
          color: "blue",
        },
      },
    ],
    images: [
      {
        url: "/pattern.png",
        alt_text: "Bag Buckles",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.3 }],
  },
];

export default function useProductsByIds(productIds) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [usingFallback, setUsingFallback] = useState(false);
  const abortControllerRef = useRef(null);
  const isMountedRef = useRef(true);
  const requestIdRef = useRef(0);

  useEffect(() => {
    // Set mounted flag
    isMountedRef.current = true;

    if (!productIds || productIds.length === 0) {
      setProducts([]);
      setLoading(false);
      setUsingFallback(false);
      return;
    }

    // Generate unique request ID
    const currentRequestId = ++requestIdRef.current;

    // Cancel previous requests
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create new abort controller
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;

    setLoading(true);
    setError(null);
    setUsingFallback(false);

    const fetchProducts = async () => {
      try {
        if (currentRequestId !== requestIdRef.current || signal.aborted) {
          return;
        }

        const response = await apiRequest(
          `/products/by-ids?ids=${productIds.join(",")}`
        );

        if (currentRequestId !== requestIdRef.current || signal.aborted) {
          return;
        }

        const fetchedProducts = response.data || [];

        if (!signal.aborted && isMountedRef.current) {
          setProducts(fetchedProducts);
          setLoading(false);
          setUsingFallback(false);
        }
      } catch (err) {
        if (err.name === "AbortError") {
          return;
        }

        if (!signal.aborted && isMountedRef.current) {
          console.error("[useProductsByIds] Error fetching products:", err);
          setError(err.message || "Failed to fetch products");
          setProducts([]);
          setUsingFallback(false);
          setLoading(false);
        }
      }
    };

    fetchProducts();

    // Cleanup function
    return () => {
      isMountedRef.current = false;
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [productIds]);

  return { products, loading, error, usingFallback };
}
